






















import { RESEND_VERIFY_EMAIL } from "@/queries/user/mutation.graphql";
import Vue from "vue";
export default Vue.extend({
  name: "verify-email-alert",
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async resendVerify() {
      this.loading = true;
      const {
        data: { resendVerifyEmail },
        errors
      } = await this.$apollo.mutate({
        mutation: RESEND_VERIFY_EMAIL
      });
      this.loading = false;
      if (resendVerifyEmail.affected_rows) {
        this.$toastr.s("Verification email has been sent to your email");
      }
    }
  }
});
